import { useEffect } from "react";

import { FadeTransition } from "@/components/animations/FadeTransition";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { ORGANISATION_USER_TESTS_FOR_REVIEW_QUERY } from "@/graphql/organisations/queries/patients";
import { useTableControls } from "@/tpo/Table";
import { useQuery } from "@apollo/client";

import NewResultsAvailable from "./ui/NewResultsAvailable";
import PatientsTemplate from "./ui/Template";

export const NEW_RESULTS_SORT_OPTIONS = [
  { label: "Newest to oldest", value: "-created" },
  { label: "Oldest to newest", value: "created" },
  { label: "Patient A - Z", value: "user__last_name" },
  { label: "Patient Z - A", value: "-user__last_name" }
];

export default function NewResults() {
  const { organisation } = useOrganisationContext();

  const {
    page,
    sort,
    debouncedSearch,
    search,
    setSearch,
    setPage,
    setSort,
    sortMenuOpen,
    setSortMenuOpen
  } = useTableControls({
    sortOptions: NEW_RESULTS_SORT_OPTIONS
  });

  useEffect(() => {
    setPage(1);
  }, [debouncedSearch, sort, setPage]);

  const { data, loading } = useQuery(ORGANISATION_USER_TESTS_FOR_REVIEW_QUERY, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-and-network",
    variables: {
      organisation: parseInt(organisation?.id),
      page,
      orderBy: sort,
      search: debouncedSearch
    },
    skip: !organisation
  });

  const pagination = data?.organisationUserTestsForReviewPagination;
  const userTests = pagination?.items;
  const pageInfo = pagination?.pageInfo;

  return (
    <PatientsTemplate active="new_results">
      <FadeTransition in>
        <NewResultsAvailable
          userTests={userTests}
          loading={loading}
          pageInfo={pageInfo}
          search={search}
          setSearch={setSearch}
          sort={sort}
          setSort={setSort}
          sortMenuOpen={sortMenuOpen}
          setSortMenuOpen={setSortMenuOpen}
          setPage={setPage}
          sortingOptions={NEW_RESULTS_SORT_OPTIONS}
        />
      </FadeTransition>
    </PatientsTemplate>
  );
}
